import React from 'react';
import styled from 'styled-components';

// custom components
import Notifier from 'pages/Notifier';
import ModalManager from 'pages/ModalManager';
import Appbar from 'components/Appbar';
import { useAuth } from 'context/auth/AuthContext';
import AppRoutes from 'routes';

const FullScreenDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: lightgray;
`;

function App() {
  const user = useAuth();

  return (
    <FullScreenDiv>
      {/* Global components */}
      <>
        <Notifier />
        <ModalManager />
        {user && <Appbar />}
      </>
      {/* App routes, for more information view routes/routes */}
      <AppRoutes />
    </FullScreenDiv>
  );
}

export default App;
